module.exports = __webpack_public_path__ + "static/media/logo_agrupado_sinfondo.d7c7f6ac.png";